import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "c-news-section__grid" }
const _hoisted_3 = {
  key: 0,
  class: "c-news-section__media"
}
const _hoisted_4 = { class: "c-news-section__content" }
const _hoisted_5 = { class: "c-news-section__meta" }
const _hoisted_6 = {
  key: 1,
  class: "c-news-section__date"
}
const _hoisted_7 = ["href", "target", "rel", "aria-label"]

import { computed } from 'vue';
import { RichText, Text as JssText } from '@sitecore-jss/sitecore-jss-vue';
import type { NewsSectionItemFields, NewsSectionProps } from '@/types/components/NewsSection';
import type { ScItem } from '@/types/sitecore';
import utils from '@/utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'NewsSection',
  props: {
    dataSource: {},
    fields: {},
    rendering: {},
    params: {}
  },
  setup(__props: any) {

const props = __props;
const fields = computed(() => props.fields);
const rendering = computed(() => props.rendering);

const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'c-news-section'));
const rootStyle = computed(() => utils.overall?.baseComStyle?.(fields.value) || {});

const rawItems = computed<ScItem<NewsSectionItemFields>[]>(() => {
  const newsItems = utils.sc.getFieldObj(fields.value, 'items');
  return Array.isArray(newsItems) ? newsItems : [];
});

const getAdaptiveImageField = (image: any) => {
  if (image?.fields?.desktopImage) return image;
  if (!image?.value?.src) return null;

  return {
    fields: {
      desktopImage: image,
      mobileImage: image,
      tabletImage: image,
    },
  };
};

const items = computed(() => rawItems.value.filter((item) => item.fields));

const getTagClass = (tag: string) =>
  tag.toLowerCase() === 'news' ? 'c-news-section__tag--news' : 'c-news-section__tag--article';

const getLinkHref = (item: ScItem<NewsSectionItemFields>) => item.fields?.link?.value?.href || '';

const getLinkLabel = (item: ScItem<NewsSectionItemFields>, index: number) => {
  const linkValue = item.fields?.link?.value || {};
  return linkValue.text || linkValue.title || item.fields?.title?.value || `News item ${index + 1}`;
};

const cardClass = (index: number) => {
  if (index === 0) return 'c-news-section__card--feature';
  if (index === 3) return 'c-news-section__card--wide';
  return 'c-news-section__card--compact';
};

return (_ctx: any,_cache: any) => {
  const _component_AdaptiveImage = _resolveComponent("AdaptiveImage")!
  const _component_ContentGrid = _resolveComponent("ContentGrid")!

  return (fields.value && items.value.length)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: _normalizeClass(rootClass.value),
        style: _normalizeStyle(rootStyle.value),
        id: rendering.value?.dataSource
      }, [
        _createVNode(_component_ContentGrid, {
          "desktop-default-grid": [2, 20],
          "mobile-default-grid": [1, 14]
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
                return (_openBlock(), _createElementBlock("article", {
                  key: item.id,
                  class: _normalizeClass(["c-news-section__card", cardClass(index)])
                }, [
                  (item.fields?.image)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_component_AdaptiveImage, {
                          class: "c-news-section__image",
                          field: getAdaptiveImageField(item.fields.image),
                          "is-background": false,
                          show: true,
                          "enable-scroll-detection": false,
                          "show-image-redius": false
                        }, null, 8, ["field"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      (item.fields?.tag?.value)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: _normalizeClass(["c-news-section__tag", getTagClass(item.fields.tag.value)])
                          }, _toDisplayString(item.fields.tag.value), 3))
                        : _createCommentVNode("", true),
                      (item.fields?.date?.value)
                        ? (_openBlock(), _createElementBlock("time", _hoisted_6, _toDisplayString(item.fields.date.value), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (item.fields?.title?.value)
                      ? (_openBlock(), _createBlock(_unref(RichText), {
                          key: 0,
                          class: "c-news-section__title",
                          field: item.fields.title,
                          tag: "h3"
                        }, null, 8, ["field"]))
                      : _createCommentVNode("", true),
                    (index === 0 && item.fields?.summary?.value)
                      ? (_openBlock(), _createBlock(_unref(RichText), {
                          key: 1,
                          class: "c-news-section__summary",
                          field: item.fields.summary
                        }, null, 8, ["field"]))
                      : _createCommentVNode("", true)
                  ]),
                  (getLinkHref(item))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        class: "c-news-section__link",
                        href: getLinkHref(item),
                        target: item.fields?.link?.value?.target,
                        rel: item.fields?.link?.value?.target === '_blank' ? 'noopener noreferrer' : undefined,
                        "aria-label": getLinkLabel(item, index)
                      }, [...(_cache[0] || (_cache[0] = [
                        _createElementVNode("span", { "aria-hidden": "true" }, null, -1)
                      ]))], 8, _hoisted_7))
                    : _createCommentVNode("", true)
                ], 2))
              }), 128))
            ])
          ]),
          _: 1
        })
      ], 14, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})